import type { SupabaseClient } from "@supabase/supabase-js";

export const sharedResources = [
  "contacts",
  "contact_notes",
  "tasks",
  "sales",
  "companies",
  "deals",
  "deal_notes",
  "tags",
  "configuration",
] as const;

/** Invalidate cached views; never copy event payloads into the local record. */
export function subscribeToWorkspace(
  client: SupabaseClient,
  refresh: () => void,
) {
  let timer: ReturnType<typeof setTimeout> | undefined;
  let active = true;
  const scheduleRefresh = () => {
    if (!active) return;
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (active) refresh();
    }, 250);
  };
  const channel = client.channel("nars-workspace");
  for (const table of sharedResources) {
    channel.on(
      "postgres_changes",
      { event: "*", schema: "public", table },
      scheduleRefresh,
    );
  }
  channel.on("system", {}, (message) => {
    // The socket may join before Postgres replication is ready on a cold start.
    if (message.status === "ok") scheduleRefresh();
  });
  channel.subscribe((status) => {
    // Also catch writes missed while the connection was interrupted.
    if (status === "SUBSCRIBED") scheduleRefresh();
  });
  return () => {
    active = false;
    clearTimeout(timer);
    void client.removeChannel(channel);
  };
}
